// extracted by mini-css-extract-plugin
export default {"root":"pending-approval-badge_root__Ql6t3","note":"pending-approval-badge_note__bem2A","icon":"pending-approval-badge_icon__E3-Ns"};